import { Type } from 'class-transformer';
import { Route } from '@/models/trip/Route';

export class ContinuousWork {
  public id = '';

  @Type(() => Route)
  public routes: Route[] = [];
}
